/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplications_creditApplications_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null };

export type GetCreditApplications_creditApplications_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly startedAt: any | null, readonly shouldBeExpiredAt: any | null, readonly status: _Types.CreditApplicationStatus | null, readonly fundableLimit: number | null, readonly businessInfo: GetCreditApplications_creditApplications_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null };

export type GetCreditApplications_Query = { readonly __typename: 'Query', readonly creditApplications: ReadonlyArray<GetCreditApplications_creditApplications_CreditApplication> | null };


export type GetCreditApplicationsVariables = _Types.Exact<{ [key: string]: never; }>;


export type GetCreditApplications = GetCreditApplications_Query;


export const GetCreditApplicationsDocument = gql`
    query GetCreditApplications {
  creditApplications {
    salesforceCreditId
    businessInfo {
      legalBusinessName
    }
    startedAt
    shouldBeExpiredAt
    status
    fundableLimit
  }
}
    `;

/**
 * __useGetCreditApplications__
 *
 * To run a query within a React component, call `useGetCreditApplications` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplications` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplications({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditApplications(baseOptions?: Apollo.QueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
      }
export function useGetCreditApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
        }
export function useGetCreditApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
        }
export type GetCreditApplicationsHookResult = ReturnType<typeof useGetCreditApplications>;
export type GetCreditApplicationsLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationsLazyQuery>;
export type GetCreditApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationsSuspenseQuery>;
export type GetCreditApplicationsQueryResult = Apollo.QueryResult<GetCreditApplications, GetCreditApplicationsVariables>;